import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BrowserService } from '../services/browser.service';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class PromoSaveGuard {
  constructor(
    private browserService: BrowserService,
    private storage: StorageService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<true> {
    if (isPlatformServer(this.platformId)) return true;
    const loggedIn = this.browserService.getCookies()?.['picflow-loggedin'] === 'true';
    if (loggedIn) return true;

    const promoCode = next.queryParams.promo;
    if (promoCode) this.storage.set('promo', promoCode);
  }
}
